/**
 * The zone the API books `schedule` in: the location's own zone (what
 * `resolveScheduleTimezone` puts first), else the business's. The booking
 * window's last day is counted in it, so the date picker must use the
 * selected location's zone, not the business's.
 */
export function bookingTimeZoneFor(
  schedule: { timezone?: string | null } | null | undefined,
  businessTimeZone?: string | null,
): string | null {
  const own = schedule?.timezone?.trim();
  return own || businessTimeZone || null;
}
